import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { Grid, TextField, Typography } from '@mui/material';
import { LactateFormValues } from '../../formModel';
import { Modality } from '../../types';
import { unitsForModality } from '../../constants';

interface Props {
  control: Control<LactateFormValues>;
  modality: Modality;
  errors: Record<string, string>;
}

export const Vo2Section: React.FC<Props> = ({ control, modality, errors }) => {
  const { intensityUnit } = unitsForModality(modality);
  const fieldsDef: { key: keyof LactateFormValues['vo2']; label: string }[] = [
    { key: 'max_output', label: `Max output (${intensityUnit})` },
    { key: 'vo2max', label: 'VO₂max (mL/kg/min)' },
    { key: 'max_hr', label: 'Max HR (bpm)' },
    { key: 'ventilation', label: 'Ventilation (L/min)' },
    { key: 'tidal_volume', label: 'Tidal volume (L)' },
    { key: 'resp_frequency', label: 'Respiratory frequency (breaths/min)' },
  ];

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>
        VO₂max & maximal effort
      </Typography>
      <Grid container spacing={2}>
        {fieldsDef.map((f) => (
          <Grid item xs={12} sm={6} md={4} key={f.key}>
            <Controller
              name={`vo2.${f.key}` as const}
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={f.label}
                  fullWidth
                  size="small"
                  error={Boolean(errors[`vo2.${f.key}`])}
                  helperText={errors[`vo2.${f.key}`]}
                />
              )}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
